export default __webpack_public_path__ + "static/media/wonderglobe.9206054e.svg";